import React from 'react'

import s from './styles.module.scss'

import { SeasonEnum } from '../../../../../../../../../lib/graphql'

const PriceSeasonColorTag = ({
  season,
  width = 10,
  height = 10,
}: {
  season: SeasonEnum
  width?: number
  height?: number
}) => {
  const seasonColors = {
    [SeasonEnum.HIGH]: '#ff0000',
    [SeasonEnum.MEDIUM]: '#f1960d',
    [SeasonEnum.LOW]: '#0cbc8b',
  }

  return (
    <div
      className={s.seasonColorTag}
      style={{ backgroundColor: seasonColors[season], width, height }}
    />
  )
}

export default PriceSeasonColorTag
